import { Language, LANGUAGE_STORAGE_KEY, LANGUAGES } from "./constants";

// Only explicit picks (the switcher or `?lng`) are stored, so a stored value
// always outranks a portal's default and gets saved to the account.

/** The language picked on this device, if any. */
export const storedLanguage = (): Language | null => {
  try {
    const value = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return LANGUAGES.find((language) => language === value) ?? null;
  } catch {
    return null;
  }
};

export const rememberLanguage = (language: Language) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Storage blocked: the pick still applies for this visit.
  }
};
